<template>
    <div>
        <header class="bg-[#212121] text-white shadow-md">
            <div class="flex items-center justify-between px-4 py-3">
                <!-- 좌측 메뉴 -->
                <div class="flex items-center space-x-4">
                    <!-- 햄버거 메뉴 -->
                    <div class="relative">
                        <button @click="showMenu = !showMenu" class="p-2 rounded-md hover:bg-gray-700 focus:outline-none">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                            </svg>
                        </button>
                        
                        <!-- 드롭다운 메뉴 -->
                        <div v-if="showMenu" class="absolute top-full left-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50">
                            <div class="py-1" @click="showMenu = false">
                                <a v-for="(item, index) in items" :key="index" 
                                   @click="$router.push(item.path)"
                                   class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
                                    {{ item.title }}
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- 타이틀 -->
                    <h1 class="text-xl font-semibold">PWARRIS</h1>
                </div>

                <!-- 우측 아이콘들 -->
                <div class="items-center space-x-2">
                    <!-- 와이파이 아이콘 -->
                    <button class="p-2 rounded-md hover:bg-gray-700 focus:outline-none">
                        <svg v-if="bIsOnline" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"></path>
                        </svg>
                        <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636"></path>
                        </svg>
                    </button>

                    <!-- 새로고침 아이콘 -->
                    <button @click="clearCash()" class="p-2 rounded-md hover:bg-gray-700 focus:outline-none">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>
                    </button>

                    <!-- 뒤로가기 아이콘 -->
                    <button v-if="$route.name !== 'Home'" @click="$router.go(-1)" class="p-2 rounded-md hover:bg-gray-700 focus:outline-none">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </header>

        <!-- 메뉴 오버레이 (모바일용) -->
        <div v-if="showMenu" @click="showMenu = false" class="fixed inset-0 z-40 bg-black bg-opacity-25 lg:hidden"></div>
    </div>
</template>

<script>
import { menuList } from '@/router'

export default {
    name: 'AppHeader',
    props: {
    },
    data() {
        return {
            items: menuList,
            bIsOnline: '',
            showMenu: false
        }
    },
    created() {
        // 앱이 처음 실행될 때 온라인 또는 오프라인 상태변경될 때 실행되는 콜백 함수로 fnIsOnline() 연결
        window.addEventListener('online', this.fnIsOnline)
        window.addEventListener('offline', this.fnIsOnline)
        // 앱의 처음 상태 결정
        this.fnIsOnline()
    },
    methods: {
        // 온라인 또는 오프라인 상태를 인지하여 부울 변수값 변경
        fnIsOnline() {
            if (navigator.onLine) {
                this.bIsOnline = true
            } else {
                this.bIsOnline = false
            }
        },
        clearCash() {
            // 1. Service Worker 캐시 삭제
            if ('caches' in window) {
                caches.keys().then(cacheNames => {
                cacheNames.forEach(cacheName => {
                    caches.delete(cacheName); // 모든 캐시 삭제
                });
                });
            }

            // 2. Service Worker 업데이트 (강제 새로 고침)
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.getRegistrations().then(registrations => {
                registrations.forEach(registration => {
                    registration.unregister(); // 기존 service worker 등록 해제
                });
                });
            }

            // 3. 브라우저 캐시 및 리소스 강제 새로 고침
            window.location.reload(true); // true: 강제로 캐시를 무시하고 리로드
        }
    }
}
</script>